// Please, add new constants into new files in /src/constants/ folder
// TODO Split one enormous file to some small, group constants by meaning.

export const API_ROOT_URI = `https://${process.env.REACT_APP_API_BASE_URL}/v2.0`;
export const API_BASE_URI = `https://${process.env.REACT_APP_API_BASE_URL}`;

export const api = {
  AUTH_USER: `${API_ROOT_URI}/auth/tokens`,
  AUTH_WITH_2FA_CODE_USER: `${API_ROOT_URI}/auth/tokens/2fa/verify`,
  AUTH_WITH_2FA_CODE_RESEND_USER: `${API_ROOT_URI}/auth/tokens/2fa/resend`,
  GET_USER: `${API_ROOT_URI}/user`,
  CREATE_USER: `${API_ROOT_URI}/users`,
  GET_USER_ETAG: `${API_ROOT_URI}/user/etag`,
  UPDATE_RESOURCE: `${API_ROOT_URI}/resources`,
  SEND_PASSWORD_RESET_CODE: `${API_ROOT_URI}/user/password/reset/codes`,
  SEND_EMAIL_VERIFICATION_LINK: `${API_ROOT_URI}/user/email/verification/email`,
  SEND_PHONE_VERIFICATION_CODE: `${API_ROOT_URI}/user/phone/verification/codes`,
  SEND_2FA_VERIFICATION_CODE: `${API_ROOT_URI}/user/email/2fa/enable`,
  SEND_DISABLED_2FA_VERIFICATION_CODE: `${API_ROOT_URI}/user/email/2fa/disable`,
  RESET_PASSWORD: `${API_ROOT_URI}/user/password/reset`,
  UPDATE_PASSWORD: `${API_ROOT_URI}/user/password`,
  VERIFY_CODE: `${API_ROOT_URI}/user/phone/verification/codes`,
  VERIFY_2FA_CODE: `${API_ROOT_URI}/user/email/2fa/enable/verify`,
  VERIFY_DISABLED_2FA_CODE: `${API_ROOT_URI}/user/email/2fa/disable/verify`,
  UPLOAD_DOCUMENT: `${API_ROOT_URI}/documents`,
  GET_ACCOUNT: `${API_ROOT_URI}/accounts`,
  ADD_ACCOUNT: `${API_ROOT_URI}/user/accounts`,
  REMOVE_ACCOUNT: `${API_ROOT_URI}/user/accounts`,
  CREATE_ACCOUNT: `${API_ROOT_URI}/accounts`,
  GET_SLATE: `${API_ROOT_URI}/slates`,
  GET_SLATE_VIEWS_LIST: `${API_ROOT_URI}/accounts`,
  GET_SLATES: `${API_ROOT_URI}/accounts`,
  GET_IMAGE: `${API_ROOT_URI}/documents/images`,
  GET_SLATE_VIEW_SETTINGS: `${API_ROOT_URI}/accounts`,
  GET_JOBS: `${API_ROOT_URI}/accounts`,
  CREATE_JOB: `${API_ROOT_URI}/accounts`,
  GET_NOTIFICATIONS: `${API_ROOT_URI}/accounts/`,
  CREATE_NOTIFICATION: `${API_ROOT_URI}/resources/notification/`,
  DELETE_NOTIFICATION: `${API_ROOT_URI}/accounts/`,
  GET_TIME_ZONES: `${API_ROOT_URI}/timezones/iana/`,
  GENERATE_DEMO_SLATE: `${API_ROOT_URI}/accounts`,
  GET_TEMPLATES: `${API_ROOT_URI}/accounts`,
  VALIDATE_SCRIPT: `${API_ROOT_URI}/scripts/validate`,
  OAUTH_AUTHORIZE_COMPLETE: `${API_BASE_URI}/oauth/authorize/complete`,
  OAUTH_AUTHORIZE_DENY: `${API_BASE_URI}/oauth/authorize/deny`,
};

export const CHAT_API_BASE = process.env.REACT_APP_SLATEMATE_API_BASE;
export const chatApi = {
  CREATE_SESSION: '/api/chat-generate-slate/sessions',
  GET_SESSION: function (id) { return '/api/chat-generate-slate/sessions/' + id; },
  DELETE_SESSION: function (id) { return '/api/chat-generate-slate/sessions/' + id; },
  SEND_MESSAGE: function (id) { return '/api/chat-generate-slate/sessions/' + id + '/messages'; },
};

export const layouts = {
  SIGN: 'sign',
  DASHBOARD: 'dashboard',
  SLATE: 'slate',
};

export const route = {
  // Public
  START: '/start',
  CREATE_PROFILE: '/create-profile',
  RESET_PASSWORD: '/reset-password',
  OAUTH_CONSENT: '/oauth/consent',
  SUPPORT_IOS: '/.well-known/apple-app-site-association',
  // SUPPORT_ANDROID: '/.well-known/assetlinks.json',

  // Private
  ROOT: '/',
  PROFILE: '/profile',
  STACK: '/stack',
  API_KEY: '/stack/apikey',

  // Tab shorthand routes (redirect to deep-link with current account/view)
  VIEW_TAB: '/view',
  INSPECT_TAB: '/inspect',

  // Private // Slate Views
  SLATE_VIEWS: '/slate-views/', // it uses for redirects only
  SLATE_VIEW: '/accounts/:accounts/views/:views?',
  SLATE_VIEW_SETTINGS: '/settings/accounts/:accounts/views/:views',
  SLATE_VIEW_NEW: '/views/new',

  SLATE_VIEW_SEARCH_REDIRECT: '/search/',
  SLATE_VIEW_SEARCH: '/search/:searchString',

  // Private // Tools
  SLATE_GENERATOR: '/slate-generator',
  EXPORT: '/export',
  EXPORT_NEW_JOB: '/export/new',
  NOTIFICATIONS: '/notifications',
  NOTIFICATIONS_EDIT: '/notifications/:notificationUUID',
  NOTIFICATIONS_NEW: '/notifications/new',

  // Private // Slate
  SLATE: '/slates/:slateUUID',

  // Private // Scripts
  SCRIPTS: '/scripts',

  // Private // Inspect
  INSPECT: '/accounts/:accounts/inspect',
  INSPECT_SELECTION: '/accounts/:accounts/inspect/:inspectionUUID?',
  INSPECT_SELECTION_TYPE: '/accounts/:accounts/inspect/:inspectionUUID/at/:assetTypeValue',
  INSPECT_ALL: '/accounts/:accounts/inspect/all',
  INSPECT_ASSET_TYPE: '/accounts/:accounts/inspect/at/:assetTypeHash/:assetTypeValue?',
  INSPECT_NEW: '/accounts/:accounts/inspect/new/:section?',
  INSPECT_SETTINGS: '/accounts/:accounts/inspect/:inspectionUUID/configuration/:section?',

  // Dynamic content route
  DYNAMIC_CONTENT: '/custom-module/:slug',
};

export const routeTitles = {
  HOME: 'home',
  PROFILE_SETTINGS: 'profileSettings',
  STACK_SETTINGS: 'stackSettings',
  API_KEY: 'apiKey',
  SLATE_VIEWS: 'slateViews',
  SLATE_VIEW_SETTINGS: 'slateViewSettings',
  SLATE_VIEW_NEW: 'slateViewNew',
  SLATE_VIEW_SEARCH: 'searchResults',
  SLATE_GENERATOR: 'slateGenerator',
  EXPORT: 'export',
  EXPORT_NEW_JOB: 'newExportJob',
  SLATE: 'slate',
  DYNAMIC_CONTENT: 'dynamicContent',
  NOTIFICATIONS: 'notifications',
  NOTIFICATION_NEW: 'notificationNew',
  NOTIFICATION_EDIT: 'notificationEdit',
  SCRIPTS: 'scripts',
  INSPECT: 'inspect',
  INSPECT_SELECTION: 'inspect',
  INSPECT_SELECTION_TYPE: 'inspect',
  INSPECT_ALL: 'inspect',
  INSPECT_ASSET_TYPE: 'inspect',
  INSPECT_NEW: 'inspectNew',
  INSPECT_SETTINGS: 'inspectSettings',
};

export const entityNames = {
  CREATE_AUTH_TOKEN: 'CreateAuthTokenCommand',
  LOGIN_2FA_CODE_VERIFICATION: 'loginWith2faCodeVerification',
  GET_USER: 'user:get', // ToDo
  CREATE_USER: 'CreateUserCommand',
  UPDATE_USER: 'User',
  GET_USER_ETAG: 'user:etag', // ToDo
  UPDATE_PASSWORD: 'UpdatePasswordCommand',
  SEND_PASSWORD_RESET_CODE: 'SendPasswordResetCodeCommand',
  VERIFY_PASSWORD_RESET_CODE: 'VerifyPasswordResetCodeCommand',
  RESET_PASSWORD: 'ResetPasswordCommand',
  VERIFY_PHONE_VERIFICATION_CODE: 'VerifyPhoneVerificationCodeCommand',
  VERIFICATION_ENABLE_2FA_CODE: 'verification:enable2faCode', // ToDo
  VERIFICATION_DISABLE_2FA_CODE: 'verification:disable2faCode', // ToDo
  VERIFICATION_ENABLE_2FA_CODE_BACK: 'verificationEnable2faCodeBack', // ToDo
  VERIFICATION_DISABLE_2FA_CODE_BACK: 'verificationDisable2faCodeBack', // ToDo
  VERIFICATION_EMAIL: 'verification:email', // ToDo
  VERIFICATION_SMS: 'verification:sms', // ToDo
  VERIFICATION_CALL: 'verification:call', // ToDo
  DASHBOARD_SETTINGS: 'DashboardSettings',
  UPDATE_ACCOUNT_TIMESTAMP: 'UpdateAccountTimestamp',
  ADD_ACCOUNT: 'AddAccountToUserProfileCommand',
  REMOVE_ACCOUNT: 'accounts:remove', // ToDo
  GET_ACCOUNT: 'account:get', // ToDo
  UPDATE_ACCOUNT: 'Account',
  GET_API_KEYS: 'apiKeys:get',
  CREATE_API_KEY: 'CreateAPIKeyCommand',
  REMOVE_API_KEY: 'DeleteAPIKeyCommand',
  UPDATE_API_KEY: 'APIKey',
  GET_SLATE: 'slate:get',
  UPDATE_SLATE: 'Slate',
  UPLOAD_DOCUMENT: 'document:upload',
  GET_SLATE_VIEWS_LIST: 'slateViewsList:get',
  GET_SLATE_VIEW: 'slateView:get',
  GET_SLATES: 'slates:get',
  SEARCH: 'Search',
  GET_SLATE_VIEW_SETTINGS: 'GetSlateViewSettings',
  UPDATE_LIST_VIEW: 'ListView',
  UPDATE_MAP_VIEW: 'MapView',
  DELETE_VIEW: 'DeleteViewCommand',
  CHANGE_TIME_ZONE: 'ChangeTimeZone',
  GET_SETTINGS_FIELDS: 'GetSettingsFields',
  GET_SETTINGS_OPERATORS: 'GetSettingsOperators',
  GET_JOBS: 'GetJobs',
  UPDATE_EXPORT_JOB: 'ExportJob',
  UPDATE_NOTIFICATION: 'UpdateNotification',
  CREATE_JOB: 'CreateJob',
  CLONE_JOB: 'CloneJob',
  RERUN_JOB: 'RerunJob',
  REMOVE_JOB: 'RemoveJob',
  GET_RECORD_ENTRIES: 'GetRecordEntries',
  GET_RECORD_SLATE: 'GetRecordSlate',
  GET_HISTORY_ENTRIES: 'GetHistoryEntries',
  UPDATE_RECORD_ENTRY: 'UpdateRecordEntry',
  GET_INSPECTIONS: 'inspections:get',
  GET_INSPECTION: 'inspection:get',
  CREATE_INSPECTION: 'CreateInspectionCommand',
  UPDATE_INSPECTION: 'Inspection',
  DELETE_INSPECTION: 'DeleteInspectionCommand',
  GET_INSPECTION_RECORDS: 'inspectionRecords:get',
  GET_INSPECTION_SCHEDULED: 'inspectionScheduled:get',
  GET_INSPECTION_PERFORMANCE: 'inspectionPerformance:get',
  POST_INSPECTION_DEFICIENCY: 'inspectionDeficiency:post',
  GET_INSPECTION_ACTIVITY: 'inspectionActivity:get',
  GET_INSPECTION_VOID_PREVIEW: 'inspectionVoidPreview:get',
  POST_INSPECTION_VOID: 'inspectionVoid:post',
  POST_FEATURE_ACCESS_REQUEST: 'featureAccessRequest:post',
};

export const resourceTypes = {
  USER: 'user',
  ACCOUNT: 'account',
  API_KEY: 'apikey',
  SLATE: 'slate',
  LIST_VIEW: 'listview',
  MAP_VIEW: 'mapview',
  JOB: 'exportjob',
  INSPECTION: 'inspection',
};

export const fieldsTypes = {
  TEXT: 'text',
  BOOLEAN: 'boolean',
  SELECTOR: 'selector',
  NUMBER: 'number',
  LOCATION: 'location',
  EMAIL: 'email',
  URL: 'url',
  PHONE: 'phone',
  DATETIME: 'dateTime',
  PHOTO: 'photo',
  GROUP: 'group',
  JOURNAL: 'journal',
  RECORDS: 'records',
  IMAGE: 'image',
  DESCRIPTION: 'description',
  ACTIONS: 'actions',
};

export const entryDetailsTypes = {
  USER_DISPLAY_NAME: 'userDisplayName',
  TIMESTAMP: 'timestamp',
};

export const entryDetails = {
  [entryDetailsTypes.USER_DISPLAY_NAME]: {
    isShown: true,
    recordEntryAttribute: entryDetailsTypes.USER_DISPLAY_NAME,
    title: "User Display Name",
    type: "",
    mainType: 'Entry_Details',
  },
  [entryDetailsTypes.TIMESTAMP]: {
    isShown: true,
    recordEntryAttribute: entryDetailsTypes.TIMESTAMP,
    title: "Timestamp",
    type: "",
    mainType: 'Entry_Details',
  },
};

export const filteringFieldsForRecordListView = [
  {
    isShown: true,
    suuid: "Entry_Details",
    title: "Entry Details",
    type: "",
    disable: true,
  },
  entryDetails.userDisplayName,
  entryDetails.timestamp,
  {
    isShown: true,
    suuid: "Entry_Fields",
    title: "Entry Fields",
    type: "",
    disable: true,
  },
]

export const filteringFieldsForRecordListViewOtherFields = [
  {
    isShown: true,
    suuid: "Other_Fields",
    title: "Other Fields",
    type: "",
    disable: true,
  },
]

export const settingsOperatorsEntryDetails = {
  timestamp: {
    allowedOperators: [
      "equals",
      "doesntEqual",
      "lessThan",
      "lessThanEqualTo",
      "greaterThan",
      "greaterThanEqualTo",
    ]
  },
  userDisplayName: {
    allowedOperators: [
      "equals",
      "doesntEqual",
      "contains",
      "doesntContain",
    ]
  },
};

export const apiKeyRoles = {
  SLATE_UPDATE: 'slateupdate',
  SLATE_IMPORT: 'slateimport',
};

export const infoPanelTypes = {
  WARNING: 'warning',
};

export const booleanDisplayTypes = {
  RED_GREEN: 'redGreen',
  TRUE_FALSE: 'trueFalse',
  YES_NO: 'yesNo',
  ON_OFF: 'onOff',
};

export const dateTimeDisplayTypes = {
  DATE: 'date',
  DATE_TIME: 'dateTime',
};

export const dateTimeFormats = {
  DATE: 'MM/DD/YYYY',
  DATE_TIME: 'MM/DD/YYYY h:mm a',
};

export const avatarShapes = {
  CIRCLE: 'CIRCLE',
  ROUNDED_CORNERS: 'ROUNDED_CORNERS',
};

export const sortTypes = {
  ASC: 'asc',
  DESC: 'desc',
};

export const imageSizes = {
  USER_TOPBAR: {
    width: 40,
    height: 40,
  },
  PROFILE_SETTINGS: {
    width: 100,
    height: 100,
  },
  ACCOUNT_SIDEBAR: {
    width: 80,
    height: 80,
  },
  ACCOUNT_LIST: {
    width: 44,
    height: 44,
  },
  SLATE_ACCOUNT: {
    width: 40,
    height: 40,
  },
  SLATE_HEADER: {
    height: 400,
  },
  SLATE_IMAGE: {
    height: 180,
  },
  MAP_VIEW: {
    width: 40,
    height: 40,
  },
  SEARCH_ITEM: {
    width: 50,
    height: 50,
  },
  HISTORY_ITEM: {
    width: 120,
    height: 120,
  },
  ACTIVITY_AVATAR: {
    width: 16,
    height: 16,
  },
};

// Longest-edge resolution (in px) each Claude model processes natively.
// The Anthropic API downscales any image larger than this to fit, server-side,
// preserving aspect ratio -- so uploading anything bigger only costs upload
// size and latency with zero fidelity or token-cost benefit.
// Source: https://platform.claude.com/docs/en/build-with-claude/vision
export const CLAUDE_NATIVE_IMAGE_EDGE_PX = {
  'claude-sonnet-4-6': 1568,
  'claude-opus-4-7': 2576,
  'claude-opus-4-8': 2576,
};

// The model SlateMate's chat backend currently targets. When the backend
// switches models, update this key (the dashboard cannot read the backend's
// model directly, so this is a hand-maintained mirror).
export const SLATEMATE_CHAT_MODEL = 'claude-sonnet-4-6';

// The long-edge target we downscale attached images to before sending.
export const SLATEMATE_IMAGE_MAX_EDGE_PX =
  CLAUDE_NATIVE_IMAGE_EDGE_PX[SLATEMATE_CHAT_MODEL]; // 1568 for Sonnet 4.6

export const slateViewsTypes = {
  LIST: 'list',
  MAP: 'map',
};

export const imageLoadingStatuses = {
  LOADING: 'loading',
  LOADED: 'loaded',
  FAILED: 'failed',
};

export const logicOperatorTypes = {
  AND: 'and',
  OR: 'or',
};

export const ruleParts = {
  RECORD_ENTRY_ATTRIBUTE: 'recordEntryAttribute',
  FIELD_SUUID: 'fieldSUUID',
  OPERATOR: 'operation',
  PATTERN: 'value',
};

export const selectorOperators = {
  EQUALS: 'equals',
  DOESNT_EQUAL: 'doesntEqual',
  EXIST_ON_SLATE: 'existsOnSlate',
  DOESNT_EXIST_ON_SLATE: 'doesntExistOnSlate',
  HAS_VALUE: 'hasValue',
  DOESNT_HAVE_VALUE: 'doesntHaveValue',
};

export const notificationTypes = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

export const fieldsDnDId = {
  AVAILABLE: 'available',
  SELECTED: 'selected',
};

export const jobsTabs = {
  ACTIVE: 'active',
  FAVORITES: 'favorites',
  ARCHIVED: 'archived',
};

export const jobsStatuses = {
  STARTING: 'starting',
  PROCESSING: 'processing',
  FINISHING: 'finishing',
  FINISHED: 'finished',
  ERROR: 'error',
};

export const columnTypes = {
  FIELD: 'field',
  METADATA: 'metadata',
};

export const fieldAttributeOptions = ['value', 'user', 'timestamp'];

export const dynamicDate = 'todayNow';

export const minSearchLength = 1;

export const localStorageProps = {
  MAP_TYPE: 'mapType',
  CURRENT_ACCOUNT: 'currentAccount',
  THEME_MODE: 'themeMode',
};

export const mapTypes = {
  ROADMAP: 'roadmap',
  SATELLITE: 'satellite',
  HYBRID: 'hybrid',
  TERRAIN: 'terrain',
};

export const patchOptions = {
  REPLACE: 'replace',
  ADD: 'add',
};

export const presetNames = {
  mediumIfPhoto: 'medium-if-photo',
  medium: 'medium',
};

export const listViewTypes = {
  slates: 'slates',
  records: 'recordEntries',
};

export const slateTypes = {
  slate: 'slate',
  record: 'recordEntry',
};

export const paneContentModes = {
  SLATE: 'slate',
  TEMPLATE: 'template',
  DEMO: 'demo',
};

export const slatePaneGroups = {
  VIEWS: 'views',
  GENERATOR: 'generator',
  SCRIPTS: 'scripts',
  CUSTOM: 'custom',
  INSPECT: 'inspect',
};

export const INSPECT_DUE_BEFORE_NOW = '__inspectDueBeforeNow__';
export const INSPECT_DUE_FROM_NOW = '__inspectDueFromNow__';
export const INSPECT_STATUS_UPCOMING = '__inspectStatusUpcoming__';

// User roles read by the dashboard. Granted server side only (Cosmos edit); users cannot set them.
export const userRoles = {
  USE_INSPECT: 'useInspect',
};

// Feature names for POST v2.0/accounts/{uuid}/feature-access-requests.
export const featureAccess = {
  INSPECT: 'inspect',
};
